module.exports = __webpack_public_path__ + "static/media/QualtricsXM_Step1_Image12.20786c02.webp";